import { connect } from 'react-redux'

import {
  setFilterByRating,
  getOrderReview,
  setFilterSortReview,
} from 'reduxpath/ducks/Project/Management'

import FilterBox from './units'

const mapStateToProps = state => ({
  filterReview: state.ProjectManagement.filterReview,
  orderDetail: state.ProjectDetail.data,
})

const mapDispatchToProps = dispatch => ({
  setFilterByRating(data, orderId) {
    return () => {
      dispatch(setFilterByRating(data))
      dispatch(getOrderReview(
        {
          order: orderId,
          rating: data,
        },
        () => {},
        ['profile', 'reviewedBy'],
      ))
    }
  },

  setFilterSortReview(searchParam, orderId) {
    return (e) => {
      dispatch(setFilterSortReview(e.target.value))

      const param = {
        order: orderId,
        ...searchParam,
      }

      if (param.rating === 0) {
        delete param.rating
      }

      dispatch(getOrderReview(
        param,
        () => {},
        ['profile', 'reviewedBy'],
        e.target.value,
      ))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterBox)
